import { PhoenixMetrics } from "@amzn/ads-phoenix-type-script-client";
import type { InsightType } from "@amzn/d16-g-client-deck-builder-typescript-client";
import { useEffect } from "react";

import { TELEMETRY_ID, PHOENIX_FEATURE } from "../../constants/telemetry";
import { getPhoenixContentInfoFromStore } from "../../utils/phoenix.utils";
import { logWithTakt } from "../../utils/telemetry.utils";

export interface ContentCardShownProps {
    identifier: string | undefined;
    insightType: InsightType;
}

export const useContentCardShown = ({
    identifier,
    insightType,
}: ContentCardShownProps): void => {
    useEffect(() => {
        logWithTakt(TELEMETRY_ID.INSIGHT_CARD, {
            insightType,
            identifier,
        });
        PhoenixMetrics.emit(
            TELEMETRY_ID.INSIGHT_CARD,
            PHOENIX_FEATURE.CONTENT,
            {
                contentInfo: getPhoenixContentInfoFromStore(
                    insightType,
                    identifier,
                ),
            },
        );
    }, [insightType, identifier]);
};
